export const clients = {
  en: [
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/tui-deutschland/1743775558.svg',
      alt: 'TUI Deutschland',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/MediaMarkt/1722831911.svg',
      alt: 'MediaMarket',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/inspire-digital/1743688536.svg',
      alt: 'InspireDigital',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Samsung electronics/1722833704.svg',
      alt: 'Samsung electronics',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/trustpilot/1742822288.svg',
      alt: 'Trustpilot',
    },
  ],
  us: [
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/capital-farm-credit,-aca/1743688630.svg',
      alt: 'Capital Farm Credit, ACA',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/pro-scan-reading-services,-llc/1743688692.svg',
      alt: 'ProScan Reading Services, LLC',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Siemens/1722832408.svg',
      alt: 'Siemens',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/A.T. Kearney, Inc./1722604308.svg',
      alt: 'A.T. Kearney, Inc.',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/flsmidth-inc./1743688741.svg',
      alt: 'FLSmidth Inc.',
    },
  ],
  uk: [
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Samsung electronics/1722833704.svg',
      alt: 'Samsung',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Yunex Traffic/1722835569.svg',
      alt: 'YUNEX TRAFFIC',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/RiverIsland/1722833585.svg',
      alt: 'River Island',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Zuto/1722835605.svg',
      alt: 'Zuto',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/National Grid/1722832635.svg',
      alt: 'National Grid',
    },
  ],
  de: [
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/tui-deutschland/1743775558.svg',
      alt: 'TUI Deutschland',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Verivox GmbH/1722835214.svg',
      alt: 'Verivox GmbH',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Publicis Media/1723470983.svg',
      alt: 'Publicis Media',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/whiteLogo/Eurofunk Kappacher GmbH/1722602295.svg',
      alt: 'Eurofunk Kappacher GmbH',
    },
    {
      icon: 'https://content.andersenlab.com/common-data/white-logo/zdf-digital/1743777378.svg',
      alt: 'ZDF Digital',
    },
  ],
};
